import { render, staticRenderFns } from "./RunnitBoardMembersManagement.vue?vue&type=template&id=44b882fb&scoped=true"
import script from "./RunnitBoardMembersManagement.vue?vue&type=script&lang=ts"
export * from "./RunnitBoardMembersManagement.vue?vue&type=script&lang=ts"
import style0 from "./RunnitBoardMembersManagement.vue?vue&type=style&index=0&id=44b882fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b882fb",
  null
  
)

export default component.exports